export const ImportMatchingPhoneColumnName = 'phone'
export const ImportMatchingEmailColumnName = 'email'
export const ImportMatchingGroupsColumnName = 'groups'
export const ImportMatchingGroupTypeColumnName = 'group_type'
